<template>
  <section class="wow fadeIn">
    <div class="card border-0 fadingBidHeadlineWrapper">
      <div class=" d-flex justify-content-center align-items-center">
        <div class="card-body">
          <div class="container-fluid ">
            <div class="container text-center ">
              <h2
                class="productheadlineh2 wow fadeInDown surgicalSmokeNoPartOfOperatingHeadline"
              >
                {{ $t("surgical_smoke_not_integral_part_operating_room") }}
              </h2>
              <h2
                class="productheadline wow fadeInUp smokeEvacuationProtectsHeadline"
              >
                {{ $t("smoke_evacuation_protects") }}
              </h2>
              <h2 class="superbold wow fadeInUp surgicalteamAndPatientHeadline">
                {{ $t("surgical_team")
                }}<span class="plusIconSection3">&#73;</span>
                {{ $t("patient") }}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FadingBigHeadline"
};
</script>

<style scoped>
.fadingBidHeadlineWrapper {
  background-image: url("../../assets/images/background-symbol.jpg");
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 56vw;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
}
.surgicalSmokeNoPartOfOperatingHeadline {
  color: white;
  letter-spacing: 3px;
  margin-bottom: 50px;
}
.smokeEvacuationProtectsHeadline {
  color: white;
  margin-bottom: 20px;
  letter-spacing: 6px;
}
.surgicalteamAndPatientHeadline {
  color: white;
  letter-spacing: 4px;
}

.plusIconSection3 {
  font-family: "Netto Icons";
}

@media (max-width: 575.98px) {
  .surgicalSmokeNoPartOfOperatingHeadline {
    font-size: 1rem;
    margin-bottom: 2rem;
    margin-top: 1rem;
  }
  .smokeEvacuationProtectsHeadline {
    font-size: 1rem;
    margin-bottom: 0;
  }
  .surgicalteamAndPatientHeadline {
    font-size: 1.8rem;
  }
  .container {
    padding: 0;
  }
  h2 {
    padding: 0;
  }
}
@media (max-width: 767.98px) and (min-width: 576px) {
  .surgicalSmokeNoPartOfOperatingHeadline {
    font-size: 1.3rem;
    margin-bottom: 1rem;
  }
}
</style>
